import { View } from 'foundations-components/components/View';
import * as RequestStatusTypes from '../../constants/RequestStatusTypes';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const ActiveThemePresetCard = ({
  activeThemePresetId,
  presetsRequestStatus,
  onBrowsePresetsClick
}) => {
  if (presetsRequestStatus === RequestStatusTypes.PENDING) {
    return /*#__PURE__*/_jsx(View, {
      children: "Loading preset..."
    });
  }
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: onBrowsePresetsClick,
      children: activeThemePresetId || 'No preset selected'
    })
  });
};
export default ActiveThemePresetCard;